import { Create, Typography } from "@pankod/refine-mui";
import { useForm } from "@pankod/refine-react-hook-form";
import { useNavigation } from "@pankod/refine-core";
import { toast } from "react-toastify";

import axios from "utils/axios";

export default function Comp({ Fields, label, routeName, parentName }) {
  const {
    refineCore: { formLoading, queryResult },
    saveButtonProps,
    register,
    control,
    formState: { errors },
    getValues,
    setError,
    setValue,
    watch,
  } = useForm();

  const { push } = useNavigation();

  const path = parentName ? `${parentName}/${routeName}` : `${routeName}`;

  const handleCreate = async (e, values) => {
    e.preventDefault();
    try {
      // create entry
      let { data } = await axios.post(`/api/users`, values);
      //redirect to list page
      push(`/${path}`, "_self");
    } catch (error) {
      console.log("Create Error", error);
      toast.error("Something went wrong while creating entry");
    }
  };

  return (
    <Create
      isLoading={formLoading}
      saveButtonProps={{ onClick: (e) => handleCreate(e, getValues()) }}
      title={<Typography variant="h5">Crea {label}</Typography>}
    >
      <Fields
        register={register}
        control={control}
        errors={errors}
        getValues={getValues}
        setError={setError}
        setValue={setValue}
        watch={watch}
        disabled={false}
      />
    </Create>
  );
}
